import React, { FC } from 'react';
import s from './bonusToyCard.module.scss';
import { useGetBonusToy } from '@hooks/TRPC_Hooks/useGetBonusToy';
import cn from 'classnames';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { ArtistAvatar } from '@components/UIKit/ArtistAvatar/ArtistAvatar';
import { RarityIcon } from '@components/UIKit/RarityIcon/RarityIcon';
import Link from 'next/link';
import { LinksEnum } from '@specs/navigation';
import { useTranslation } from '@hooks/useTranslation';
import { Buttons } from '@components/Pages/ToyPage/Info/Buttons/Buttons';
import { useGetToyDataOnPage } from '@hooks/useGetToyDataOnPage';
import { CollectButton } from './CollectButton';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
type BonusToyCardProps = {
  collectionId: number;
  className?: string;
};
export const BonusToyCard: FC<BonusToyCardProps> = ({
  collectionId,
  className
}) => {
  const {
    data: bonusToy
  } = useGetBonusToy({
    id: collectionId
  });
  const {
    translate: tr
  } = useTranslation();
  const {
    isArtClub,
    haveFigurinesForSale,
    isArtClubMember,
    isCollectable,
    isLoading,
    currentDrop,
    artist,
    collection,
    firstStoreItem,
    myFirstStoreItem,
    isBonusToy,
    toy,
    isHaveToyInCollection,
    iAmTheCreator,
    earnFromCollectionCount
  } = useGetToyDataOnPage({
    toyId: bonusToy?.toyid ?? -1
  });
  if (isLoading) return <LogoLoader />;
  if (!toy) return null;
  const {
    name,
    slug,
    imageid,
    raritytype
  } = toy;
  const canCollect = (earnFromCollectionCount ?? 0) >= (collection?.toysTotal ?? 0);
  return <div className={cn(s.bonusToyCard, className)} data-sentry-component="BonusToyCard" data-sentry-source-file="BonusToyCard.tsx">
            <div className={s.bonusToyCard__body}>
                <div className={s.bonusToyCard__top}>
                    <div className={s.bonusToyCard__row}>
                        <div className={s.bonusToyCard__artist}>
                            {!!artist?.profile?.shortid && <ArtistAvatar shortId={artist.profile.shortid} srcSet={[{
              height: 24,
              width: 24,
              minMedia: 0
            }]} />}
                        </div>
                        {raritytype && <RarityIcon rarityId={raritytype} width={24} height={24} />}
                    </div>
                    <Link href={{
          pathname: LinksEnum.TOY,
          query: {
            slug
          }
        }} data-sentry-element="Link" data-sentry-source-file="BonusToyCard.tsx">
                        <OptimizedImage boxClassName={cn(s.bonusToyCard__image, '_shadow')} path={'/toys/cards'} cdnId={imageid} alt={name} fill data-sentry-element="OptimizedImage" data-sentry-source-file="BonusToyCard.tsx" />
                    </Link>
                </div>
                <div className={s.bonusToyCard__main}>
                    <div className={cn(s.bonusToyCard__name, '_ellipsis')}>
                        {name}
                    </div>
                    {!!collection && <div className={cn(s.bonusToyCard__collection, '_ellipsis')}>
                            {collection.name}
                        </div>}
                </div>

            </div>

            <div className={s.bonusToyCard__info}>
                <p className={s.bonusToyCard__description}>
                    {tr({
          id: 'collections.page.bonus.toy.description'
        })}
                </p>
                <div className={s.bonusToyCard__counter}>
                    {earnFromCollectionCount ?? 0} / {collection?.toysTotal ?? 0}
                </div>

                {!canCollect ? <CollectButton isDisabled /> : <Buttons slug={slug} haveFigurinesForSale={haveFigurinesForSale} isArtClubMember={isArtClubMember} isArtClub={isArtClub} myFirstStoreItem={myFirstStoreItem} firstStoreItem={firstStoreItem} isLoading={isLoading} currentDrop={currentDrop} isCollectable={isCollectable} toyId={toy.id} toyName={name} imageid={imageid} isBonusToy={isBonusToy} collectionId={collection?.id} isHaveToyInCollection={isHaveToyInCollection} iAmTheCreator={iAmTheCreator} publication={toy.publication} buttonProps={{
        size: 'medium',
        color: 'Black'
      }} />}


            </div>
        </div>;
};